/**
 * VIVI sticky ATC — mobile PDP.
 * Fixed to bottom (above mbar). Only visible AFTER scrolling past the main ATC.
 *
 * Size label sync: Dawn replaces <variant-selects> on every option change, so we
 * re-query the live picker each time and listen via delegation / pubsub.
 *
 * Sold-out must come from the variant payload — never from button label/disabled
 * (that caused a sticky “Sold out” feedback loop).
 */
(function () {
  function strings() {
    return window.viviAtcStrings || {};
  }

  function boot(root) {
    if (!root || root.dataset.viviStickyReady) return;
    root.dataset.viviStickyReady = '1';

    /* Escape section transforms so position:fixed is viewport-true */
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var sectionId = root.getAttribute('data-section-id') || '';
    var hasOptions = root.getAttribute('data-has-options') === 'true';
    var stickyBtn = root.querySelector('[data-vivi-sticky-atc-btn]');
    var stickyLabel = root.querySelector('[data-vivi-sticky-atc-label]');
    var mainBtn = document.querySelector('[data-vivi-main-atc]');
    var productForm =
      document.querySelector('product-form[data-section-id="' + sectionId + '"]') ||
      document.querySelector('product-form');

    if (!stickyBtn || !stickyLabel || !mainBtn) return;

    function getVariantRoot() {
      return (
        document.querySelector('#variant-selects-' + sectionId) ||
        document.querySelector('variant-selects')
      );
    }

    function getMainLabel() {
      return (
        mainBtn.querySelector('[data-vivi-atc-label]') ||
        document.querySelector('[data-vivi-atc-label]')
      );
    }

    function sizeFieldset() {
      var variantRoot = getVariantRoot();
      if (!variantRoot) return null;
      var fields = Array.prototype.slice.call(
        variantRoot.querySelectorAll('fieldset.product-form__input')
      );
      var size = fields.find(function (fs) {
        var legend = fs.querySelector('legend');
        return legend && /size/i.test(legend.textContent || '');
      });
      return size || fields[0] || null;
    }

    function selectedSizeValue(variant) {
      if (variant) {
        var opts = variant.options || [];
        if (opts.length) {
          var variantRoot = getVariantRoot();
          var fields = variantRoot
            ? Array.prototype.slice.call(
                variantRoot.querySelectorAll(
                  'fieldset.product-form__input, .product-form__input--dropdown'
                )
              )
            : [];
          var sizeIndex = -1;
          fields.forEach(function (fs, i) {
            var label =
              (fs.querySelector('legend') && fs.querySelector('legend').textContent) ||
              (fs.querySelector('.form__label') && fs.querySelector('.form__label').textContent) ||
              '';
            if (/size/i.test(label)) sizeIndex = i;
          });
          if (sizeIndex < 0) sizeIndex = 0;
          if (opts[sizeIndex]) return opts[sizeIndex];
        }
        if (variant.option1) return variant.option1;
      }

      var fs = sizeFieldset();
      if (!fs) return null;
      var checked = fs.querySelector('input:checked');
      if (checked) return checked.value;
      var select = fs.querySelector('select');
      if (select && select.value) return select.value;
      return null;
    }

    /* S → Small, etc. so ATC reads “Add Small to bag” */
    function sizeDisplayName(raw) {
      if (!raw) return '';
      var key = String(raw).trim().toUpperCase();
      var map = {
        XXS: 'XX-Small',
        XS: 'Extra Small',
        S: 'Small',
        M: 'Medium',
        L: 'Large',
        XL: 'Extra Large',
        XXL: 'XX-Large',
        '2XL': 'XX-Large',
        '3XL': 'XXX-Large',
        '4XL': 'XXXX-Large',
      };
      if (map[key]) return map[key];
      return String(raw).trim();
    }

    function hasSelection() {
      if (!hasOptions) return true;
      var variantRoot = getVariantRoot();
      if (!variantRoot) return true;
      if (variantRoot.querySelector('fieldset input:checked')) return true;
      var select = variantRoot.querySelector('select');
      return !!(select && select.value);
    }

    /**
     * Availability only from variant data.
     * Never infer from label text or [disabled] — those caused a permanent Sold out lock.
     */
    function isSoldOut(variant, source) {
      if (mainBtn && mainBtn.getAttribute('data-vivi-product-available') === 'false') {
        return true;
      }
      if (variant && typeof variant.available === 'boolean') {
        return variant.available === false;
      }
      /* Invalid / missing combination after Dawn fetch */
      if (source === 'variantChange' && !variant) return true;
      /* Option change in flight — don't lock sold-out on stale state */
      return false;
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function labelHtml(variant, source) {
      var s = strings();
      if (hasOptions && !hasSelection()) return s.selectSize || 'Select size';
      if (isSoldOut(variant, source)) return s.soldOut || 'Sold out';
      var size = sizeDisplayName(selectedSizeValue(variant));
      if (size) {
        return (s.addSizeToBag || 'Add {size} to bag').replace(
          '{size}',
          '<span class="vivi-atc-size">' + escapeHtml(size) + '</span>'
        );
      }
      return s.addToBag || 'Add to bag';
    }

    function setLabel(el, html) {
      if (!el) return;
      if (html.indexOf('<') !== -1) el.innerHTML = html;
      else el.textContent = html;
    }

    function syncLabels(variant, source) {
      var needsSize = hasOptions && !hasSelection();
      var soldOut = !needsSize && isSoldOut(variant, source);
      var html = labelHtml(variant, source);

      setLabel(stickyLabel, html);
      setLabel(getMainLabel(), html);

      stickyBtn.classList.toggle('is-select-size', needsSize);
      stickyBtn.disabled = soldOut;

      if (mainBtn) {
        if (needsSize) {
          mainBtn.removeAttribute('disabled');
          mainBtn.classList.add('is-select-size');
        } else if (soldOut) {
          mainBtn.setAttribute('disabled', 'disabled');
          mainBtn.classList.remove('is-select-size');
        } else {
          mainBtn.removeAttribute('disabled');
          mainBtn.classList.remove('is-select-size');
        }
      }
    }

    function scrollToSizes() {
      var target =
        getVariantRoot() ||
        document.querySelector('.product-form__input--pill') ||
        document.querySelector('variant-selects');
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      target.classList.add('vivi-size-highlight');
      window.setTimeout(function () {
        target.classList.remove('vivi-size-highlight');
      }, 1200);
    }

    function triggerAdd() {
      if (!mainBtn || mainBtn.hasAttribute('disabled')) return;
      mainBtn.click();
    }

    stickyBtn.addEventListener('click', function () {
      if (hasOptions && !hasSelection()) {
        scrollToSizes();
        return;
      }
      if (isSoldOut(null, 'click')) return;
      triggerAdd();
    });

    mainBtn.addEventListener(
      'click',
      function (event) {
        if (hasOptions && !hasSelection()) {
          event.preventDefault();
          event.stopPropagation();
          scrollToSizes();
        }
      },
      true
    );

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (event) {
          if (hasOptions && !hasSelection()) {
            event.preventDefault();
            event.stopPropagation();
            scrollToSizes();
          }
        },
        true
      );
    }

    /* Delegation — survives Dawn replacing <variant-selects> on each pick */
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (!t.closest('#variant-selects-' + sectionId) && !t.closest('variant-selects')) return;
      window.requestAnimationFrame(function () {
        syncLabels(null, 'optionChange');
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        window.requestAnimationFrame(function () {
          syncLabels(variant, 'variantChange');
        });
      });
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        window.requestAnimationFrame(function () {
          syncLabels(null, 'optionChange');
        });
      });
    }

    /* Only show after the main ATC has been scrolled past (above the viewport) */
    function updateVisibility() {
      var rect = mainBtn.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      root.classList.toggle('is-visible', scrolledPast);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
    syncLabels(null, 'init');
  }

  function init() {
    document.querySelectorAll('[data-vivi-sticky-atc]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
